// Image Swatch System for Product Variants
// Handles variant selection and form updates

(function() {
  'use strict';

  class ImageSwatchSystem {
    constructor() {
      this.init();
    }

    init() {
      this.root = document.querySelector('variant-radios') || document;
      this.bindEvents();
      this.updateFormData();
    }

    bindEvents() {
      // Listen for variant selection changes
      this.root.addEventListener('change', (event) => {
        if (event.target.classList.contains('image-swatch-input')) {
          this.handleVariantChange(event.target);
        }
      });

      // Handle click events on swatch items
      this.root.addEventListener('click', (event) => {
        const swatchItem = event.target.closest('.image-swatch-item');
        if (swatchItem) {
          const radioInput = swatchItem.querySelector('.image-swatch-input');
          if (radioInput && !radioInput.disabled) {
            const wasChecked = radioInput.checked;
            radioInput.checked = true;
            if (!wasChecked) {
              // Fire native change so Dawn updates price/media/etc.
              radioInput.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
        }
      });
    }

    handleVariantChange(radioInput) {
      const swatchItem = radioInput.closest('.image-swatch-item');
      const optionName = radioInput.name;
      const optionValue = radioInput.value;

      // Update visual selection state
      this.updateSelectionState(optionName, optionValue);

      // Update form data
      this.updateFormData();

      // Trigger variant change event
      this.triggerVariantChangeEvent(radioInput);
    }

    updateSelectionState(optionName, selectedValue) {
      // Remove selected state from all swatch items in this option group
      const swatchItems = document.querySelectorAll(`.image-swatch-item`);
      swatchItems.forEach(item => {
        item.classList.remove('selected');
      });

      // Add selected state to the chosen swatch item
      const selectedItem = document.querySelector(`input[name="${optionName}"][value="${selectedValue}"]`).closest('.image-swatch-item');
      if (selectedItem) {
        selectedItem.classList.add('selected');
      }
    }

    updateFormData() {
      // Update hidden variant ID input - look for the correct selector
      const variantInput = document.querySelector('.product-variant-id');
      if (variantInput) {
        const selectedVariantId = this.getSelectedVariantId();
        if (selectedVariantId) {
          variantInput.value = selectedVariantId;
          // Enable the input so it gets submitted
          variantInput.disabled = false;
        }
      }

      // Also update the standard variant ID input that the main system expects
      const standardVariantInput = document.querySelector('input[name="id"]');
      if (standardVariantInput) {
        const selectedVariantId = this.getSelectedVariantId();
        if (selectedVariantId) {
          standardVariantInput.value = selectedVariantId;
        }
      }
    }

    getSelectedVariantId() {
      // Get the selected swatch item
      const selectedSwatch = document.querySelector('.image-swatch-input:checked');
      if (!selectedSwatch) return null;

      // Get the variant ID from the data attribute
      const swatchItem = selectedSwatch.closest('.image-swatch-item');
      if (swatchItem) {
        return swatchItem.dataset.variantId;
      }

      return null;
    }

    triggerVariantChangeEvent(radioInput) {
      // Create and dispatch a custom variant change event
      const event = new CustomEvent('variant:change', {
        detail: {
          optionName: radioInput.name,
          optionValue: radioInput.value,
          variantId: this.getSelectedVariantId()
        },
        bubbles: true
      });
      document.dispatchEvent(event);
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new ImageSwatchSystem());
  } else {
    new ImageSwatchSystem();
  }
})();
